import { Accordion, ButtonBase, styled as muiStyled, Paper } from '@mui/material'

export const GiftCardRedeemNextStepsAccordion = muiStyled(Accordion)(
  ({ theme }) => `
    background: transparent !important;
    color: #fff;
        &:before {
    display: none;
    }
  // margin-bottom: 35px;
    .MuiAccordionSummary-content{
      display: flex;
      justify-content: center;
    }

`,
)

export const SuccessProceedToAppDialogPaper = muiStyled(Paper)(
  ({ theme }) => `

                padding: 16px;
                margin: 8px !important;
                max-width: 570px !important;
                width: 100%;
                border-radius: 8px;

  `,
)

export const GiftCardRedeemNextStepsTabularAccordion = muiStyled(Accordion)(
  ({ theme }) => `
    background: transparent !important;
    color: #000;
    &:before {
    display: none;
    }
    .MuiAccordionSummary-content{
      display: flex;
      justify-content: center;
    }

`,
)

export const GiftCardRedeemNextStepsTab = muiStyled(ButtonBase)(
  ({ theme, selected }) => `
    color: #000000c2;
    
    border: 1px solid ${selected ? '#000' : '#c9c9c9'};
    background: #fff;
    font-weight: ${selected ? '600' : '400'};
    padding: 5px 10px;
    border-radius: 50px;
`,
)
